import React from "react";
import BaseUpload from "../BaseUpload";
import { YxComponent } from "../../../YxComponent";
import { get, random, merge } from "../../../../utils";
import uploadFileS3 from "../../../../utils/upload/uploadFileS3";

/**
 * s3上传，契合文轩版本
 *
 * @class UploadS3
 * @extends {YxComponent}
 */
class UploadS3 extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.uploadFile = get(
      this.props,
      "uploadFile",
      new uploadFileS3(this.props)
    );
    this.id = random();
  }

  get extraUploadParam() {
    return {};
  }

  beforeUploadExtraAction = async (file) => {
    await this.uploadFile.getFile(file);
  };

  /**
   * 获得凭证
   *
   * @param {object} props
   * @memberof UploadS3
   */
  getSign = async (setState, ossFactory) => {
    await this.uploadFile.getSign(null, null, ossFactory);
    setState({ loading: false, spin: false });
  };

  filterDoneFile = (fileList, uploadFileList) => {
    const result = [];
    for (let file of fileList) {
      const uid = get(file, "uid", null);
      const status = get(file, "status", null);
      if (status === "done") {
        let url = get(file, "url", null);
        if (url == null) {
          const item = uploadFileList.find((u) => get(u, "uid", null) === uid);
          const url = get(item, "url", "");
          result.push({ ...file, url });
        } else {
          result.push(file);
        }
      }
    }
    return result;
  };

  /**
   * 每个云实现自己的url转换逻辑
   * 直接决定表单的值和展示出来的图片
   *
   * @param {File} {file,fileList，uploadFormList}
   * @returns (urls fullUrls)
   * @memberof UploadOss
   */
  getValueFromHandle = ({ filterList }) => {
    const uploadFileList = this.uploadFile.uploadFileList;
    const fileList_ = this.filterDoneFile(filterList, uploadFileList);
    const result = {
      urls: fileList_.map((f) => f.url),
      completeUrls: fileList_,
    };
    return result;
  };

  get param() {
    const result = {
      getSign: this.getSign,
      uploadFile: this.uploadFile,
      uploadUrl: this.uploadFile.uploadFileUrl,
      extraUploadParam: this.extraUploadParam,
      getValueFromHandle: this.getValueFromHandle,
      beforeUploadExtraAction: this.beforeUploadExtraAction,
    };
    return merge(result, this.props);
  }

  render() {
    return <BaseUpload {...this.param} />;
  }
}

export default UploadS3;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/Upload-S3/index.js